// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  max-width: 800px;
  margin: 0 auto;
}

.welcome-section {
  text-align: center;
  margin-bottom: 24px;
}

.welcome-section h1 {
  font-size: 36px;
  margin-bottom: 8px;
}

.welcome-section p {
  font-size: 18px;
  color: var(--text-light);
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 16px;
  text-align: center;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-card.points {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #333;
}

.stat-card.streak {
  background: linear-gradient(135deg, #FF6B6B, #FF8E53);
  color: white;
}

.stat-card.words {
  background: linear-gradient(135deg, #2E7D32, #43A047);
  color: white;
}

.stat-icon {
  font-size: 28px;
  margin-bottom: 4px;
}

.stat-card .stat-value {
  font-size: 32px;
  font-weight: 800;
  color: inherit;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
}

.quick-actions {
  display: grid;
  gap: 16px;
  margin-bottom: 24px;
}

.action-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-decoration: none;
  color: var(--text);
  box-shadow: var(--shadow);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
}

.action-card:hover {
  transform: translateX(8px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.action-icon {
  font-size: 40px;
}

.action-title {
  font-size: 20px;
  font-weight: 700;
}

.action-desc {
  font-size: 14px;
  color: var(--text-light);
}

.action-card .action-title,
.action-card .action-desc {
  display: block;
}

.review-badge {
  position: absolute;
  right: 20px;
  background: var(--danger);
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
}

.today-stats {
  text-align: center;
}

.today-stats h3 {
  margin-bottom: 12px;
}

.today-stats p {
  margin: 8px 0;
  font-size: 16px;
}

@media (max-width: 600px) {
  .stats-row {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".home {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.welcome-section {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.welcome-section h1 {\n  font-size: 36px;\n  margin-bottom: 8px;\n}\n\n.welcome-section p {\n  font-size: 18px;\n  color: var(--text-light);\n}\n\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 16px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stat-card.points {\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  color: #333;\n}\n\n.stat-card.streak {\n  background: linear-gradient(135deg, #FF6B6B, #FF8E53);\n  color: white;\n}\n\n.stat-card.words {\n  background: linear-gradient(135deg, #2E7D32, #43A047);\n  color: white;\n}\n\n.stat-icon {\n  font-size: 28px;\n  margin-bottom: 4px;\n}\n\n.stat-card .stat-value {\n  font-size: 32px;\n  font-weight: 800;\n  color: inherit;\n}\n\n.stat-label {\n  font-size: 12px;\n  opacity: 0.9;\n}\n\n.quick-actions {\n  display: grid;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.action-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  text-decoration: none;\n  color: var(--text);\n  box-shadow: var(--shadow);\n  transition: transform 0.2s, box-shadow 0.2s;\n  position: relative;\n}\n\n.action-card:hover {\n  transform: translateX(8px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.action-icon {\n  font-size: 40px;\n}\n\n.action-title {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.action-desc {\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n.action-card .action-title,\n.action-card .action-desc {\n  display: block;\n}\n\n.review-badge {\n  position: absolute;\n  right: 20px;\n  background: var(--danger);\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.today-stats {\n  text-align: center;\n}\n\n.today-stats h3 {\n  margin-bottom: 12px;\n}\n\n.today-stats p {\n  margin: 8px 0;\n  font-size: 16px;\n}\n\n@media (max-width: 600px) {\n  .stats-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
